import React from 'react'
import PropTypes from 'prop-types'
import styles from './index.module.css'

const AuthForm = ({ children, title, onSubmit }) => {
  return (
    <form className={styles.setUpForm} onSubmit={onSubmit}>
      <h1 className={styles.setUpHeader}>{title}</h1>
      {children}
    </form>
  )
}

AuthForm.propTypes = {
  children: PropTypes.node,
  title: PropTypes.string,
  onSubmit: PropTypes.func,
}

export default AuthForm
